import type { ProductColor } from '@aloft/toolkit-shared';

import { DetailLineWithValue } from '../../../components/Analysis/ColumnComponents/DetailLineWithValue.tsx';
import { PLACEHOLDER } from '../consts.ts';
import type { ViewMode } from '../types.ts';

export const ModeAwareDetailLine = ({
  text,
  costValue,
  adj,
  viewMode,
  topBorder = false,
}: {
  text?: string;
  costValue?: string;
  adj?: { value: string; color: ProductColor };
  viewMode: ViewMode;
  topBorder?: boolean;
}) => {
  if (viewMode === 'cost') {
    return <DetailLineWithValue text={text ?? PLACEHOLDER} value={costValue} />;
  }

  return (
    <DetailLineWithValue
      text={text ?? PLACEHOLDER}
      value={adj?.value}
      valueColor={adj?.color}
      topBorder={topBorder}
    />
  );
};
